import React from 'react';
import style from './avatar.module.scss';
import DefaultAvatar from 'icons/defaultAvatar';
import Avatar, { AvatarProps } from '@mui/material/Avatar';
import { useAppSelector } from 'store/hooks';
import { selectUser } from 'store/auth/authSlice';
import cx from 'classnames';

export default function CustomAvatar(props: AvatarProps) {
  const user = useAppSelector(selectUser);

  return (
    <Avatar
      src={user?.avatar || ''}
      {...props}
      className={cx(style.container, props.className)}
    >
      {!user?.avatar && <DefaultAvatar className={style.icon}></DefaultAvatar>}
    </Avatar>
  );
}
